var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11h13V3H2zm1-7h11v6H3zm12.5-3h-14C.673 1 0 1.638 0 2.423v10.154C0 13.362.673 14 1.5 14h14c.827 0 1.5-.638 1.5-1.423V2.423C17 1.638 16.327 1 15.5 1m.5 11.577c0 .234-.225.423-.5.423h-14c-.275 0-.5-.189-.5-.423V2.423C1 2.189 1.225 2 1.5 2h14c.275 0 .5.189.5.423zM5 15h7v1H5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.43 4.291a.2.2 0 0 0-.194.201v4.846a.2.2 0 0 0 .291.18l4.846-2.434a.2.2 0 0 0 0-.36L6.527 4.314a.2.2 0 0 0-.097-.022m.625 1.2 2.847 1.415-2.847 1.43Z",
    style: {
      strokeWidth: 0.4171814
    },
    transform: "translate(.144)"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/media.svg";